import { Component, OnInit }  from '@angular/core';
import { Router }             from '@angular/router';
import { Subscription }       from 'rxjs/Subscription';

import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { AddStamplingModal } from './add-stampling-modal'

import * as providers from '../../providers/providers';
import * as models    from '../../models/models';
import * as FileSaver from 'file-saver';
import * as encoding  from 'text-encoding';
import * as XLSX      from 'xlsx';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnInit {
  stamplings: models.DailyStampling[] = []
  stamplingsRaw = false;
  users: models.StamplingUser[] = [];
  selectedUser: models.StamplingUser = null;
  selectedMonth: number[] = [2017, 0];
  user: models.FirebaseUser = null;
  isCurrentMonth: boolean = true;

  constructor(private router: Router, private modalService: NgbModal, private db: providers.StamplingDB, private holidays: providers.Holidays) {}

  ngOnInit() {
    this.user = this.db.getLoggedUser();
    console.log(this.user);
    this.selectCurrentMonth();
    this.loadAllowedUsers();
  }
  showHideRaw() {
    this.stamplingsRaw = !this.stamplingsRaw;
  }

  selectCurrentMonth() {
    let month: number = new Date().getMonth();
    let year: number = new Date().getFullYear();
    this.selectedMonth = [year, month];
    this.updateIsCurrentMonth()
  }
  precMonth() {
    let date = new Date(this.selectedMonth[0], this.selectedMonth[1]-1, 1);
    let month: number = date.getMonth();
    let year: number = date.getFullYear();
    this.selectedMonth = [year, month];
    this.updateIsCurrentMonth();
    this.selectUser(this.selectedUser);
  }
  nextMonth() {
    let date = new Date(this.selectedMonth[0], this.selectedMonth[1]+1, 1);
    let month: number = date.getMonth();
    let year: number = date.getFullYear();
    this.selectedMonth = [year, month];
    this.updateIsCurrentMonth();
    this.selectUser(this.selectedUser);
  }

  updateIsCurrentMonth() {
    let today = new Date();
    let m: number = today.getMonth();
    let y: number = today.getFullYear();
    this.isCurrentMonth = (y == this.selectedMonth[0] && m == this.selectedMonth[1])
  }
  loadAllowedUsers() {
    this.db
        .getAllowedUsers()
        .then((all) => {
          this.users = all;
          if (this.users.length==1) this.selectUser(this.users[0]);
        })
        .catch((err) => alert(err));
  }

  selectUser(u: models.StamplingUser) {
    if (this.users.indexOf(u)>=0) {
      this.stamplings = [];
      this.selectedUser = u;
      this.loadMonthStamplings()
          .catch((err) => alert(JSON.stringify(err)));
    }
  }

  deleteStampling(s: models.Stampling) {
    this.db.deleteStampling(this.selectedUser.cardid, s)
           .then(() => this.loadMonthStamplings())
           .catch ((err) => alert("impossibile cancellare timbratura: "+JSON.stringify(err)));
  }

  addNew(day: Date) {
    const modalRef = this.modalService.open(AddStamplingModal).result.then((res) => {
      if (res!=null) {
        let time: any = JSON.parse(res);
        console.log(time);
        let datetime: Date = new Date(day);
        datetime.setHours(time.hour)
        datetime.setMinutes(time.minute);

        this.db.saveStampling(this.selectedUser.cardid, datetime)
               .then(()=> this.loadMonthStamplings())
               .catch((err)=> alert(err));
      }
    }, (err) => {});

  }

  loadMonthStamplings(): Promise<models.DailyStampling[]> {
    return this.db.findStampling(this.selectedUser, this.selectedMonth[0], this.selectedMonth[1])
                  .then((stamplings) => {
                    this.stamplings = stamplings;
                    for (let i in this.stamplings) {
                      let morning = 0;
                      let afternoon = 0;
                      let st = this.stamplings[i];
                      if (st.entrance) {
                        if (st.start_pause) {
                          morning = st.start_pause.datetime.getTime() - st.entrance.datetime.getTime()
                          if (st.end_pause && st.exit) {
                            afternoon = st.exit.datetime.getTime() - st.end_pause.datetime.getTime()
                          }
                        } else if (st.exit) {
                          morning = st.exit.datetime.getTime() - st.entrance.datetime.getTime()
                        }
                      }
                      let hour = Math.floor((morning + afternoon) / 3600000);
                      let min = Math.floor((((morning + afternoon) / 3600000) - hour ) * 60)
                      this.stamplings[i].total_hour_worked = {"hour": hour, "minute": min};
                    }
                    return this.stamplings;
                  })
    ;
  }

  addStamplingNow() {
    if (this.selectedUser!=null) {
        let datetime: Date = new Date();
        this.db.saveStampling(this.selectedUser.cardid, datetime)
               .then(()=> this.loadMonthStamplings())
               .catch((err)=> alert(err));

    }
  }

  uploadingCSV: boolean = false;
  uploadCSV(fileInput) {
    if (!this.uploadingCSV) {
      this.uploadingCSV = true;

      let reader=new FileReader();
      reader.onload = (e) => {
         let csv: string = new encoding.TextDecoder("utf-8").decode(reader.result);
         let lines: string[] = csv.replace("\r", "").replace("\"", "").split("\n");
         let stamplings: Date[] = []
         for (var i=0; i<lines.length; i++) {
           let line: string[] = lines[i].split(",");
           console.log(line);
           if (line.length>1 && line[0].indexOf("/")>0) {
             //Valid line
             //console.log("is valid line")
             let dayStr: string[] = line[0].split("/");
             let day: Date = new Date(parseInt(dayStr[2], 10), parseInt(dayStr[1], 10)-1, parseInt(dayStr[0], 10), 12, 0, 0);
             for (var j=1; j<line.length; j++) {
               if (line[j].indexOf(":")>0) {
                 var timeStr: string[] = line[j].split(":");
                 let datetime: Date = new Date(day);
                 datetime.setHours(parseInt(timeStr[0]))
                 datetime.setMinutes(parseInt(timeStr[1]))
                 stamplings.push(datetime);
               }
             }
           }
         }
         //console.log("IMPORTED: ", stamplings);
         if (stamplings.length>0) {
           console.log(stamplings);
           this.db
               .saveStamplings(this.selectedUser.cardid, this.selectedMonth[0], this.selectedMonth[1], stamplings)
               .then(() => this.loadMonthStamplings())
               .catch((err) => alert(err));
         }
         this.uploadingCSV = false;
      }
      reader.readAsArrayBuffer(fileInput.target.files[0]);
    }
  }

  downloadCSV(dates) {
    var blob = new Blob([this.toCSV(dates)], { type:"text/csv;charset=utf-8;" });
    FileSaver.saveAs(blob, 'timbrature_'+this.selectedMonth[0]+"_"+(this.selectedMonth[1]+1)+"_"+this.selectedUser.name+'.csv');
  }

  toCSV(dates): string {
    let csv: string = "data;entrata;inizio_pausa;fine_pausa;uscita;\n"
    for (let i in dates) {
      let d = dates[i];
      csv+=this._format_date(d.date)+";"
      csv+=this._format_time(d.entrance)+";"
      csv+=this._format_time(d.start_pause)+";"
      csv+=this._format_time(d.end_pause)+";"
      csv+=this._format_time(d.exit)+";"
      csv+="\n"
    }
    return csv;
  }

  downloadXLSX(dates) {
    var blob = this.toXLSX(dates)
    FileSaver.saveAs(blob, 'timbrature_'+this.selectedMonth[0]+"_"+(this.selectedMonth[1]+1)+"_"+this.selectedUser.name+'.xlsx');
  }

  toXLSX(dates): Blob {
    var sheet = {'!cols': []}
    var ln=0;
    //Header
    let header: string[] = ["Data", "Entrata", "Inizio pausa", "Totale mattina", "Fine pausa", "Uscita", "Totale pomeriggio", "Totale ore lavorate"]
    for (var i=0; i<header.length; i++) {
      sheet['!cols'].push({wch: 10});
      sheet[this._xlsx_cell(i, ln)] = { t: "s", v: header[i], s: { font: {bold: true}} }
    }
    ln+=1;

    //Body
    var cellStyle = { font: { sz: "11", bold: false }};
    var cellSumStyle = { patternType: 'solid',
     fgColor: { theme: 8, tint: 0.3999755851924192, rgb: '9ED2E0' },
     bgColor: { indexed: 64 }, font: { sz: "11", bold: true }};

    let curTimeOffset = new Date().getTimezoneOffset();
    for (var j=0; j<dates.length; j++) {
      let d = dates[j];
      let correction = 0;
      if (d.entrance!=null) {
        correction = d.entrance.datetime.getTimezoneOffset()-curTimeOffset;
      }
      sheet[this._xlsx_cell(0, ln)] = { t: "d", v: d.date.toISOString().split("T")[0],        s: cellStyle }
      if (d.entrance!=null)    {
        d.entrance.datetime.setMinutes(d.entrance.datetime.getMinutes()-correction);
        sheet[this._xlsx_cell(1, ln)] = { t: "d", v: d.entrance.datetime.toISOString(), z: "HH:MM",   s: cellStyle }
      }
      if (d.start_pause!=null) {
        d.start_pause.datetime.setMinutes(d.start_pause.datetime.getMinutes()-correction);
        sheet[this._xlsx_cell(2, ln)] = { t: "d", v: d.start_pause.datetime.toISOString(), z: "HH:MM",   s: cellStyle }
      }
      if (d.end_pause!=null)   {
        d.end_pause.datetime.setMinutes(d.end_pause.datetime.getMinutes()-correction);
        sheet[this._xlsx_cell(4, ln)] = { t: "d", v: d.end_pause.datetime.toISOString(), z: "HH:MM",   s: cellStyle }
      }
      if (d.exit!=null)        {
        d.exit.datetime.setMinutes(d.exit.datetime.getMinutes()-correction);
        sheet[this._xlsx_cell(5, ln)] = { t: "d", v: d.exit.datetime.toISOString(), z: "HH:MM",   s: cellStyle }
      }

      if (d.entrance && d.start_pause) sheet[this._xlsx_cell(3, ln)] = {t: "d", z: "HH:MM", f: this._xlsx_cell(2, ln)+"-"+this._xlsx_cell(1, ln), s: cellSumStyle}
      if (d.end_pause && d.exit) sheet[this._xlsx_cell(6, ln)] = {t: "d", z: "HH:MM", f: this._xlsx_cell(5, ln)+"-"+this._xlsx_cell(4, ln), s: cellSumStyle}

      //if (d.entrance && d.start_pause && d.end_pause && d.exit) sheet[this._xlsx_cell(7, ln)] = {t: "d", z: "HH:MM", f: this._xlsx_cell(3, ln)+"+"+this._xlsx_cell(6, ln), s: cellSumStyle}
      //if (d.entrance && d.exit) sheet[this._xlsx_cell(7, ln)] = {t: "d", z: "HH:MM", f: this._xlsx_cell(5, ln)+"-"+this._xlsx_cell(1, ln), s: cellSumStyle}


      if (d.start_pause && d.end_pause) sheet[this._xlsx_cell(7, ln)] = {t: "d", z: "HH:MM", f: this._xlsx_cell(6, ln)+"+"+this._xlsx_cell(3, ln), s: cellSumStyle}
      else if (d.entrance && d.exit) sheet[this._xlsx_cell(7, ln)] = {t: "d", z: "HH:MM", f: this._xlsx_cell(5, ln)+"-"+this._xlsx_cell(1, ln), s: cellSumStyle}

      ln+=1;
    }

    //Footer
    ln+=1
    sheet[this._xlsx_cell(6, ln)] = {t: "s", v: "TOTALE"}
    sheet[this._xlsx_cell(7, ln)] = {t: "d", z: "[HH]:MM", f: "SUM("+this._xlsx_cell(7, 1)+":"+this._xlsx_cell(7, ln-1)+")", s: cellSumStyle}
    ln+=1;
    //Closure
    sheet['!ref'] = XLSX.utils.encode_range({c:0, r:0}, {c: header.length+1, r: ln+1});

    //Workbook
    var wb = XLSX.utils.book_new();
    var sheetName = this.selectedMonth[0]+"-"+(this.selectedMonth[1]+1)+"_"+this.selectedUser.name;
    sheetName = sheetName.replace(" ", "-");
    if (sheetName.length>30) sheetName = sheetName.substr(0, 30);
    wb.SheetNames.push(sheetName)
    wb.Sheets[sheetName] = sheet;
    console.log("SHEET: ", sheet);
    //Save
    var file = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary'});
    var buffer = new ArrayBuffer(file.length);
    var view = new Uint8Array(buffer);
    for (var i=0; i<file.length; i++) view[i] = file.charCodeAt(i) & 0xFF;
    return new Blob([buffer], { type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  }
  _xlsx_cell(index, lineNumber){
    return  XLSX.utils.encode_cell({c: index, r: lineNumber});
  }

  _format_date(d: Date): string {
    return d.getFullYear()+"/"+(d.getMonth()+1)+"/"+d.getDate();
  }
  _format_time(d: models.Stampling): string {
    if (d==null) return "";
    let ft: string = "";
    if (d.hour<10) ft+="0"
    ft+=d.hour+":"
    if (d.minute<10) ft+="0"
    ft+=d.minute
    return ft;
  }
}



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/pages/home/home.ts